<script>
    import Icon from '../icons/Icon.svelte';

    export let metrics = {
        totalStores: 0,
        activeStores: 0,
        blockedStores: 0,
        totalMRR: 0.00
    };
</script>

<div class="metrics-grid">
    <!-- 1. MRR Total (Receita Recorrente) -->
    <div class="metric-card highlight-mrr">
        <div class="metric-top">
            <span class="metric-label">MRR PREVISTO (RECEITA MENSAL)</span>
            <div class="metric-icon-box green">
                <Icon name="dollar-sign" size={18} />
            </div>
        </div>
        <div class="metric-value-row">
            <span class="currency">R$</span>
            <span class="value mrr-value">{parseFloat(metrics.totalMRR || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            <span class="period">/mês</span>
        </div>
        <span class="metric-footer-text">Faturamento recorrente de assinaturas ativas</span>
    </div>

    <!-- 2. Lojas Ativas -->
    <div class="metric-card">
        <div class="metric-top">
            <span class="metric-label">LOJAS ATIVAS & REGULARES</span>
            <div class="metric-icon-box emerald">
                <Icon name="check-circle" size={18} />
            </div>
        </div>
        <div class="metric-value-row">
            <span class="value">{metrics.activeStores}</span>
            <span class="total-tag">de {metrics.totalStores} total</span>
        </div>
        <span class="metric-footer-text">Restaurantes operando e com acesso liberado</span>
    </div>

    <!-- 3. Lojas Bloqueadas / Inadimplentes -->
    <div class="metric-card">
        <div class="metric-top">
            <span class="metric-label">LOJAS BLOQUEADAS</span>
            <div class="metric-icon-box rose">
                <Icon name="lock" size={18} />
            </div>
        </div>
        <div class="metric-value-row">
            <span class="value text-rose">{metrics.blockedStores}</span>
        </div>
        <span class="metric-footer-text">Com acesso suspenso por mensalidade pendente</span>
    </div>

    <!-- 4. Total de Estabelecimentos -->
    <div class="metric-card">
        <div class="metric-top">
            <span class="metric-label">BASE DE ESTABELECIMENTOS</span>
            <div class="metric-icon-box orange">
                <Icon name="building" size={18} />
            </div>
        </div>
        <div class="metric-value-row">
            <span class="value">{metrics.totalStores}</span>
            <span class="total-tag">tenants</span>
        </div>
        <span class="metric-footer-text">Total de clientes registrados na plataforma</span>
    </div>
</div>

<style>
    .metrics-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 16px;
        margin-bottom: 24px;
    }

    .metric-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 18px 20px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
        transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
    }

    .metric-card:hover {
        border-color: #CBD5E1;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        transform: translateY(-1px);
    }

    .highlight-mrr {
        background: #FFFFFF;
        border: 1px solid #BBF7D0;
        box-shadow: 0 2px 8px rgba(22, 163, 74, 0.06);
    }

    .highlight-mrr:hover {
        border-color: #86EFAC;
    }

    .metric-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .metric-label {
        font-size: 11px;
        font-weight: 700;
        color: #64748B;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    .metric-icon-box {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .metric-icon-box.green {
        background: #DCFCE7;
        color: #16A34A;
    }

    .metric-icon-box.emerald {
        background: #ECFDF5;
        color: #059669;
    }

    .metric-icon-box.rose {
        background: #FEE2E2;
        color: #DC2626;
    }

    .metric-icon-box.orange {
        background: #FFF7ED;
        color: #EA580C;
    }

    .metric-value-row {
        display: flex;
        align-items: baseline;
        gap: 6px;
    }

    .currency {
        font-size: 16px;
        font-weight: 800;
        color: #16A34A;
    }

    .value {
        font-size: 26px;
        font-weight: 800;
        color: #0F172A;
        letter-spacing: -0.5px;
    }

    .mrr-value {
        color: #16A34A;
    }

    .text-rose {
        color: #DC2626;
    }

    .period {
        font-size: 12px;
        color: #64748B;
        font-weight: 600;
    }

    .total-tag {
        font-size: 12px;
        color: #64748B;
        font-weight: 600;
    }

    .metric-footer-text {
        font-size: 12px;
        color: #94A3B8;
        line-height: 1.35;
    }
</style>
